var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 13.4062H22.6153C22.3838 11.5918 21.5564 9.90549 20.2629 8.61205C18.9695 7.31862 17.2832 6.49121 15.4688 6.25969V0H13.4063V6.25969C11.5918 6.49121 9.90549 7.31862 8.61205 8.61205C7.31862 9.90549 6.49121 11.5918 6.25969 13.4062H0V15.4688H6.25969C6.49121 17.2832 7.31862 18.9695 8.61205 20.2629C9.90549 21.5564 11.5918 22.3838 13.4063 22.6153V28.875H15.4688V22.6153C17.2832 22.3838 18.9695 21.5564 20.2629 20.2629C21.5564 18.9695 22.3838 17.2832 22.6153 15.4688H28.875V13.4062ZM14.4375 20.625C13.2137 20.625 12.0174 20.2621 10.9999 19.5822C9.98238 18.9023 9.18931 17.936 8.721 16.8054C8.25268 15.6747 8.13015 14.4306 8.36889 13.2304C8.60764 12.0301 9.19694 10.9276 10.0623 10.0623C10.9276 9.19694 12.0301 8.60764 13.2304 8.36889C14.4306 8.13015 15.6747 8.25268 16.8054 8.721C17.936 9.18931 18.9023 9.98238 19.5822 10.9999C20.2621 12.0174 20.625 13.2137 20.625 14.4375C20.6231 16.0779 19.9706 17.6506 18.8106 18.8106C17.6506 19.9706 16.0779 20.6231 14.4375 20.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI01);
export default __webpack_public_path__ + "static/media/i01.f771d964c4d3891d149d113cf8307b16.svg";
export { ForwardRef as ReactComponent };